export const day = {
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  10: "10",
  11: "11",
  12: "12",
  13: "13",
  14: "14",
  15: "15",
  16: "16",
  17: "17",
  18: "18",
  19: "19",
  20: "20",
  21: "21",
  22: "22",
  23: "23",
  24: "24",
  25: "25",
  26: "26",
  27: "27",
  28: "28",
  29: "29",
  30: "30",
  31: "31",
};
export const month = {
  1: "Jan",
  "01": "Jan",
  2: "Feb",
  "02": "Feb",
  3: "Mar",
  "03": "Mar",
  4: "Apr",
  "04": "Apr",
  5: "May",
  "05": "May",
  6: "Jun",
  "06": "Jun",
  7: "Jul",
  "07": "Jul",
  8: "Aug",
  "08": "Aug",
  9: "Sept",
  "09": "Sept",
  10: "Oct",
  11: "Nov",
  12: "Dec",
};
export const timeStamp = (timestmp) => {
  let options = {
    month: "short",
    hour: "numeric",
    minute: "numeric",
    year: "numeric",
    day: "numeric",
  };

  const dateTimeStr = new Date(parseInt(timestmp) * 1000).toLocaleString(
    "en-us",
    options
  );
  if (dateTimeStr === "Invalid Date") {
    return "No Data";
  } else {
    return dateTimeStr;
  }
};

export const validateField = (obj, maxLen) => {
  let res = {};
  Object.keys(obj).forEach((field) => {
    if (obj[field] && obj[field].length > maxLen[field]) {
      res[field] = `Max Length Exceeded (${maxLen[field]})`;
    }
  });
  return res;
};

export const validateForms = (data, dist) => {
  console.log(data);
  const newErrors = {};
  const keys = Object.keys(data);
  keys.forEach((field) => {
    console.log(data[field]);
    if (typeof data[field] === "string") {
      if (!data[field].trim()) {
        newErrors[field] = `${field} field is required`;
      }
      if (field === "phone" && !/^\d{1,10}$/.test(data[field])) {
        newErrors.phone = "Please enter a 10-digit phone number";
      }

      if (field === "zip_code" && !/^\d{1,5}$/.test(data[field])) {
        newErrors.zip_code = "Please enter a 5-digit zip code";
      }
    }
  });

  let val = validateField(data, dist);
  if (Object.keys(val).length > 0) {
    Object.keys(val).forEach((field) => {
      console.log(field);
      newErrors[field] = val[field];
    });
  }

  if (Object.keys(newErrors).length > 0) {
    // setErrors(newErrors);
    console.log(newErrors);
    return {
      success: false,
      data: newErrors,
    };
  }
  return {
    success: true,
    data: {},
  };
};
